// extracted by mini-css-extract-plugin
export default {"message":"Tooltips_message_eafd2","boldMessage":"Tooltips_boldMessage_ae1be","progressText":"Tooltips_progressText_e3a8a","needResource":"Tooltips_needResource_d9c15"};